import React from 'react';

import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import { days, ratio } from '../../../../constants/recipe_constants';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
    clearFocusedPrepItem,
    updateFocusedPrepItem,
} from '../../../../redux/reducers/recipes/recipesActions';
import {
    selectDialogState,
    selectFocusedPrepItem,
    selectOpenDialog,
    selectSelectedPrepList,
} from '../../../../redux/reducers/recipes/recipesSelectors';

interface SchedulerProps {}

export const Scheduler: React.FC<SchedulerProps> = () => {
    const dispatch = useAppDispatch();

    const selectedPrepList = useAppSelector(selectSelectedPrepList);
    const focusedPrepItem = useAppSelector(selectFocusedPrepItem);
    const dialogState = useAppSelector(selectDialogState);
    const openDialog = useAppSelector(selectOpenDialog);

    return (
        <Dialog
            fullWidth
            maxWidth={false}
            sx={{
                width: `${(1 - ratio) * 100}%`,
                marginLeft: `${ratio * 100}%`,
            }}
            open={
                openDialog &&
                dialogState === 'Scheduler' &&
                focusedPrepItem.scheduleType === 'Batches'
            }
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            onClose={() => {
                dispatch(clearFocusedPrepItem());
            }}
            BackdropProps={{
                style: { backgroundColor: 'transparent' },
            }}
        >
            <DialogTitle id="alert-dialog-title">
                {selectedPrepList}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {`I try to schedule ${selectedPrepList} for:`}
                </DialogContentText>
                <FormControl
                    variant="standard"
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: 1,
                        marginBottom: 1,
                    }}
                >
                    {focusedPrepItem.prepDays.map((value, day) => {
                        return (
                            <FormControlLabel
                                sx={{ margin: 0 }}
                                key={day}
                                labelPlacement="top"
                                control={
                                    <Checkbox
                                        checked={value}
                                        onChange={(event) => {
                                            let prepDaysCopy = JSON.parse(
                                                JSON.stringify(
                                                    focusedPrepItem.prepDays
                                                )
                                            );
                                            prepDaysCopy[day] =
                                                event.target.checked;
                                            dispatch(
                                                updateFocusedPrepItem({
                                                    prepDays: JSON.parse(
                                                        JSON.stringify(
                                                            prepDaysCopy
                                                        )
                                                    ),
                                                })
                                            );
                                        }}
                                    />
                                }
                                label={days[day]}
                            />
                        );
                    })}
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        dispatch(
                            updateFocusedPrepItem(
                                {
                                    prepDays: [
                                        false,
                                        false,
                                        false,
                                        false,
                                        false,
                                        false,
                                        false,
                                    ],
                                },
                                'PrepSchedule'
                            )
                        );
                    }}
                >
                    Back
                </Button>
                <Button
                    disabled={!focusedPrepItem.prepDays.includes(true)}
                    onClick={() => {
                        dispatch(updateFocusedPrepItem({}, 'Units'));
                    }}
                    autoFocus
                >
                    Next
                </Button>
            </DialogActions>
        </Dialog>
    );
};
